import { Component, ComponentInterface, Element, h, Host, JSX, Prop } from '@stencil/core';
import { transformTagNames } from '../../global/transform-tag-name';
import { BannerTeaserRatio } from './banner-teaser.types';
import { getDataOnFromTheme, WorkbenchTheme } from '../../shared/themes';

/**
 * @slot - Content placed inside the banner teaser
 * @slot tags - optional wb-tag elements
 * @slot footer - option wb-input and wb-button elements
 */
@Component({
  tag: 'wb-banner-teaser',
  styleUrl: 'scss/banner-teaser.scss',
  shadow: true,
})
export class BannerTeaserComponent implements ComponentInterface {
  @Element()
  public el: HTMLElement;

  /**
   * The colour scheme
   * @deprecated Use `data-on` attribute instead
   */
  @Prop({ reflect: true })
  public theme?: WorkbenchTheme;

  /** the image ratio*/
  @Prop({ reflect: false })
  public imageRatio: BannerTeaserRatio;

  /** the banner is full width */
  @Prop({ reflect: true })
  public fullWidth?: boolean = false;

  /** the banner has top padding */
  @Prop({ reflect: true })
  public topPadding: boolean = true;

  /** the image source (alternative to `srcSet`) */
  @Prop({ reflect: false })
  public imageSrc: string;

  /** the image source set (alternative to `src`) */
  @Prop({ reflect: false })
  public imageSrcSet: string;

  /** the aria label */
  @Prop({ reflect: false })
  public imageLabel: string;

  private TagNames = transformTagNames(this, 'wb-banner-teaser', ['wb-aspect-ratio']);

  public render(): JSX.Element {
    const { WbAspectRatio } = this.TagNames;

    return (
      <Host class="wb-banner-teaser" data-on={getDataOnFromTheme(this.el, this.theme)}>
        <div class="wrapper">
          <WbAspectRatio ratio={this.imageRatio}>
            <img //
              src={this.imageSrc}
              srcSet={this.imageSrcSet}
              aria-label={this.imageLabel}
            />
            <div class="tags">
              <slot name="tags" />
            </div>
          </WbAspectRatio>
          {this.fullWidth && <div class="gradient"></div>}
          <div class="content">
            <slot />
            <div class="footer">
              <slot name="footer" />
            </div>
          </div>
        </div>
      </Host>
    );
  }
}
